export class FFVideoModal {
  triggers: NodeListOf<HTMLAnchorElement>

  constructor(){
    this.triggers = document.querySelectorAll(".ff-videoModalTrigger")
    this.events()
  }

  events(){
    this.triggers.forEach(el => {
      el.addEventListener("click", this.onClick.bind(this))
    })
  }

  onClick(e: MouseEvent){
    const target = e.currentTarget
    if( !(target instanceof HTMLAnchorElement )) return
    e.preventDefault()
    const href = target.href
    const regex = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
    const videoId = regex.exec(href)?.[3]; 
    if(!videoId) return
    const url = `https://www.youtube.com/embed/${videoId}?autoplay=1`
    const frame = document.createElement("iframe")
    frame.src = url
    frame.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    frame.referrerPolicy = "strict-origin-when-cross-origin" 
    frame.allowFullscreen = true
    const wrapper = document.createElement("div")
    wrapper.classList.add("iframeWrapper")
    wrapper.appendChild(frame)
    const dialog = document.createElement("dialog")
    dialog.classList.add("ff-videoModal")
    dialog.appendChild(wrapper)
    dialog.addEventListener("close", function(){
      this.remove()
    })
    dialog.addEventListener("click", this.dialogClick.bind(this))
    document.body.appendChild(dialog)
    dialog.showModal()
  }

  dialogClick(e: MouseEvent){
    const target = e.currentTarget
    if( !(target instanceof HTMLDialogElement )) return
    const rect = target.getBoundingClientRect();
    const isInDialog = (rect.top <= e.clientY && e.clientY <= rect.top + rect.height &&
      rect.left <= e.clientX && e.clientX <= rect.left + rect.width);
    if (!isInDialog) {
      target.close();
    }
  }
}

new FFVideoModal()